var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ScaleDataSectionComponent } from 'app/reports/models/scale-list-data-component';
import { QuestionActionService } from 'app/reports/services/question-action.service';
import { ScaleResultQuestionFinderService } from 'app/reports/services/scale-result-question-finder.service';
var QuestionActionListComponent = /** @class */ (function (_super) {
    __extends(QuestionActionListComponent, _super);
    function QuestionActionListComponent(questionActionService, questionFinder) {
        var _this = _super.call(this) || this;
        _this.questionActionService = questionActionService;
        _this.questionFinder = questionFinder;
        _this._questionsByScale = {};
        _this._questionActions = {};
        return _this;
    }
    QuestionActionListComponent.prototype.ngOnInit = function () {
    };
    QuestionActionListComponent.prototype.setReportData = function (data, results, variables) {
        var _this = this;
        _super.prototype.setReportData.call(this, data, results, variables);
        this._title = data.title || "Questions";
        var questionById = this.AssessmentResult.assessment.getQuestionsListById();
        this._questionActions = {};
        (data.tableActions || []).forEach(function (ta) {
            var question = questionById[ta.questionId] || {};
            _this._questionActions[ta.questionId] = {
                scale: question.scale,
                question: question,
                action: ta.action,
                label: data.tableActionLabel,
                data: ta.data
            };
        });
        this._questionsByScale = {};
        this.ScaleResults.forEach(function (sr) {
            _this._questionsByScale[sr.scale.id] = _this.questionFinder.getQuestionsForScaleResult(_this.AssessmentResult, sr);
        });
    };
    QuestionActionListComponent.prototype.getTitle = function () {
        return this._title;
    };
    QuestionActionListComponent.prototype.getQuestionsForScaleResult = function (scaleResult) {
        // 
        if (this._questionsByScale[scaleResult.scale.id]) {
            return this._questionsByScale[scaleResult.scale.id];
        }
        return [];
    };
    QuestionActionListComponent.prototype.getActionLabel = function (question) {
        if (this._questionActions[question.id]) {
            return this._questionActions[question.id].label;
        }
        return "";
    };
    QuestionActionListComponent.prototype.hasAction = function (question) {
        return this._questionActions[question.id] !== undefined;
    };
    QuestionActionListComponent.prototype.handleAction = function (question) {
        var questionAction = this._questionActions[question.id];
        if (questionAction) {
            this.questionActionService.handleAction(questionAction);
        }
        else {
            console.error("handleAction called with question " + question.id + " and no action found for it ");
        }
    };
    return QuestionActionListComponent;
}(ScaleDataSectionComponent));
export { QuestionActionListComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/question-action-list/question-action-list.component.ts.pre-build-optimizer.js